import React, { useState, useEffect, useMemo } from "react";
import { Checkbox, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import api from "@/api/index.ts";

import type { VideoCategory } from "@/types/Categories";

import CategorySection from './CategorySection'

import "./styles/video-categories.scss";

interface Props {
  list: any[]

  onChange: (category: string) => void;
}

function VideoCategories({ onChange, list }: Props) {
  const [categories, setCategories] = useState<VideoCategory[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [lastIndexView, setLastIndexView] = useState(20);
  const [checkedCategories, setCheckedCategories] = useState(list || [])
  const [isShowAllCategories, setIsShowAllCategories] = useState<boolean>(false)

  const [genres, setGenres] = useState<any[]>([])
  const [types, setTypes] = useState<any[]>([])
  const [countries, setCountries] = useState<any[]>([])

  const getCategories = async () => {
    try {
      setIsLoading(true);
      const { data } = await api.categories.getCategoriesContentManager();

      setCategories(data?.data?.categories || []);
      setCountries(data?.data?.countries || []);
      setGenres(data?.data?.genres || []);
      setTypes(data.data.types)

    } catch (err) {
      console.error(err);
      setCategories([]);

    } finally {
      setIsLoading(false);
    }
  };

  const showAllList = () => {
    setIsShowAllCategories(true)
  };

  useEffect(() => {
    getCategories();
  }, []);

  const updateCheckedCategory = (categoryId ) => {
    const list = [...checkedCategories]
    const index = list.indexOf(categoryId)

    if(index === -1) {
      list.push(categoryId)
    } else {
      list.splice(index, 1)
    }

    onChange(categoryId);
    setCheckedCategories(list)
  }

  const gridClasses = useMemo(() => {
    const baseClasses = 'video-categories__grid';
    let openClasses  = '';

    if(isShowAllCategories) {
      openClasses += 'active'
    }

    return `${baseClasses} ${openClasses}`
  }, [isShowAllCategories])

  return (
    <div className="video-categories">
      {isLoading ? (
        <div className="app-block-loader">
          <Spin indicator={<LoadingOutlined />} />
        </div>
      ) : (
        <div className="video-categories__content">
          <div className={gridClasses}>
              <CategorySection list={categories} sectionName={'Категории'} updateCheckedCategory={updateCheckedCategory} checkedCategories={checkedCategories} />
              <CategorySection list={genres} sectionName={'Жанры'} updateCheckedCategory={updateCheckedCategory} checkedCategories={checkedCategories} />
              <CategorySection list={types} sectionName={'Типы'} updateCheckedCategory={updateCheckedCategory} checkedCategories={checkedCategories} />
              <CategorySection list={countries} sectionName={'Страны'} updateCheckedCategory={updateCheckedCategory} checkedCategories={checkedCategories} />
          </div>

          {!isShowAllCategories && (
            <div className="video-categories__control">
              <a className="link primary" onClick={showAllList}>
                Показать все
              </a>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default VideoCategories;
